import script from "./ListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ListPage.vue?vue&type=script&setup=true&lang=js"

import "./ListPage.vue?vue&type=style&index=0&id=36b408e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36b408e8"]])

export default __exports__